import React, {useEffect, useState} from "react";
import {useServiceContext} from "./ServiceContext";
import toast from "react-hot-toast";
import {isNumeric} from "../../tools/tools";
import Modal from "../../components/atoms/Modal";
import SelectModal from "../../components/atoms/SelectModal";
import InputGroup from "../../components/atoms/InputGroup";
import TextArea from "../../components/atoms/TextArea";
import BtnModal from "../../components/atoms/BtnModal";
import ViaqSelectBox from "../../components/atoms/ViaqSelectBox";

const ModalService = () => {
    const serviceOptions = [
        {value: "تعویض دستگاه", label: "تعویض دستگاه"},
        {value: "تعویض قطعه", label: "تعویض قطعه"},
        {value: "خدمات نرم افزاری", label: "خدمات نرم افزاری"},
    ];

    const {
        modalState,
        closeModal,
        serviceModalCallback,
        searchSerialNumber,
        addEditServiceState,
    } = useServiceContext();

    const [formData, setFormData] = useState({
        serviceNumber: "",
        serialNumber: "",
        serviceType: "",
        name: "",
        phoneNumber: "",
        description: "",
    });

    useEffect(() => {
        if (modalState.mode === "edit") {
            handleMultiInputChange({
                id: modalState.selectedItem.id,
                serialNumber: modalState.selectedItem.serialNumber,
                serviceType: modalState.selectedItem.service,
                name: modalState.selectedItem.nameOwner,
                phoneNumber: modalState.selectedItem.numberOwner.replace("+98", "0"),
                serviceNumber: modalState.selectedItem.serviceNumber,
                description: modalState.selectedItem.TextDetail,
            })
        } else {
            resetForm()
        }
    }, [modalState]);

    const handleInputChange = (field, value) => {
        setFormData((prev) => ({...prev, [field]: value}));
    };
    const handleMultiInputChange = (updates) => {
        setFormData((prev) => ({
            ...prev,
            ...updates,
        }));
    };
    const resetForm = () => {
        setFormData({
            serviceNumber: "",
            serialNumber: "",
            serviceType: "",
            name: "",
            phoneNumber: "",
            description: "",
        });
    };
    const handleChangeServiceSelect = (type, data) => {
        if (data) {
            if (type === "type") {
                handleInputChange("serviceType", data)
                return;
            }
            handleMultiInputChange({
                serialNumber: data.label,
                name: data.fullName,
                phoneNumber: data.phoneNumber.replace("+98", "0"),

            });

        } else {
            resetForm()
        }


    }

    const handleSubmit = () => {
        if (!formData.name.trim() || !formData.phoneNumber.trim()) {
            toast.error("مشخصات خود را کامل کنید", {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }

        if (!isNumeric(formData.phoneNumber)) {
            toast.error("شماره خود را صحیح وارد کنید", {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        serviceModalCallback(formData);

    };
    const isEdit = modalState.mode === "edit";
    const isOpen = modalState.mode !== "delete" && modalState.isOpen;
    const title = isEdit
        ? `ویرایش سرویس “${modalState.selectedItem.nameOwner}”`
        : "ثبت سرویس جدید ";
    const btnTitle = isEdit ? "تایید اطلاعات و ویرایش" : "تایید اطلاعات و افزودن";

    if (!isOpen) return null;

    return (
        <Modal title={title} closeModal={closeModal}>
            <div className="flex flex-col gap-3.6 mb-5">
                <div className={"flex flex-row gap-2"}>
                    <ViaqSelectBox
                        label="شماره سریال"
                        iconName="cpuB"
                        showIcon={true}
                        disabled={modalState.mode === "edit"}
                        defaultValue={formData.serialNumber}
                        values={addEditServiceState.searchSerialNumber}
                        onChange={(data) => {
                            if (modalState.mode !== "edit") {
                                handleChangeServiceSelect("serial", data[0])
                            }
                        }}
                        placeholder="یک گزینه را انتخاب کنید"
                        searchFunction={searchSerialNumber}
                        loading={addEditServiceState.searchLoading}
                    />

                    <ViaqSelectBox
                        label="نوع خدمات"
                        iconName="setting-3"
                        showIcon={true}
                        defaultValue={formData.serviceType}
                        values={serviceOptions}
                        onChange={(data) => {
                            if (modalState.mode !== "edit") {
                                handleChangeServiceSelect("type", data[0].value)
                            }

                        }}

                        placeholder="یک گزینه را انتخاب کنید"
                    />
                </div>

                <div className={"flex flex-row gap-2"}>
                    <InputGroup
                        placeholder="مانند علی میرهادی"
                        label="نام و نام خانوادگی مالک"
                        iconName="userF"
                        value={formData.name}
                        onChange={(e) => handleInputChange("name", e.target.value)}
                        id="name"
                    />

                    <InputGroup
                        placeholder="مانند 09215863622"
                        label="شماره تماس مالک"
                        iconName="call"
                        value={formData.phoneNumber}
                        onChange={(e) => handleInputChange("phoneNumber", e.target.value)}
                        id="phoneNumber"
                    />
                </div>


                <TextArea
                    iconName="note-2"
                    label="توضیحات (اختیاری)"
                    placeholder="توضیحات (اختیاری)"
                    width="mt-0"
                    text={formData.description}
                    onchange={(e) => handleInputChange("description", e.target.value)}
                />
            </div>

            <div className="flex items-center justify-end pt-5.5">
                <BtnModal
                    text={btnTitle}
                    accept={handleSubmit}
                    disabled={!formData.name || !formData.number}
                />
            </div>
        </Modal>
    );
};

export default ModalService;